/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { EmailQuoteRequestInfo } from "./EmailQuoteRequestInfo";
import {
  EmailQuoteRequestInfoFromJSON,
  EmailQuoteRequestInfoFromJSONTyped,
  EmailQuoteRequestInfoToJSON,
  EmailQuoteRequestInfoToJSONTyped,
} from "./EmailQuoteRequestInfo";
import type { Location } from "./Location";
import {
  LocationFromJSON,
  LocationFromJSONTyped,
  LocationToJSON,
  LocationToJSONTyped,
} from "./Location";

/**
 *
 * @export
 * @interface ManualQuoteShipmentDetails
 */
export interface ManualQuoteShipmentDetails {
  /**
   *
   * @type {string}
   * @memberof ManualQuoteShipmentDetails
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof ManualQuoteShipmentDetails
   */
  bolNumber?: string | null;
  /**
   *
   * @type {Location}
   * @memberof ManualQuoteShipmentDetails
   */
  pickupLocation: Location;
  /**
   *
   * @type {Location}
   * @memberof ManualQuoteShipmentDetails
   */
  deliveryLocation: Location;
  /**
   *
   * @type {boolean}
   * @memberof ManualQuoteShipmentDetails
   */
  isManualQuotingOpen: boolean;
  /**
   *
   * @type {string}
   * @memberof ManualQuoteShipmentDetails
   */
  companyName: string;
  /**
   *
   * @type {number}
   * @memberof ManualQuoteShipmentDetails
   */
  quoteRequestCount: number;
  /**
   *
   * @type {Array<EmailQuoteRequestInfo>}
   * @memberof ManualQuoteShipmentDetails
   */
  quoteRequestsWithCarriers: Array<EmailQuoteRequestInfo>;
  /**
   *
   * @type {number}
   * @memberof ManualQuoteShipmentDetails
   */
  totalResponseCount: number;
  /**
   *
   * @type {number}
   * @memberof ManualQuoteShipmentDetails
   */
  unreadResponseCount: number;
  /**
   *
   * @type {string}
   * @memberof ManualQuoteShipmentDetails
   */
  operationsAssignedTo?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ManualQuoteShipmentDetails
   */
  operationsAssignedAt?: OffsetDateTime | null;
}

/**
 * Check if a given object implements the ManualQuoteShipmentDetails interface.
 */
export function instanceOfManualQuoteShipmentDetails(
  value: object,
): value is ManualQuoteShipmentDetails {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("pickupLocation" in value) || value["pickupLocation"] === undefined)
    return false;
  if (!("deliveryLocation" in value) || value["deliveryLocation"] === undefined)
    return false;
  if (
    !("isManualQuotingOpen" in value) ||
    value["isManualQuotingOpen"] === undefined
  )
    return false;
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  if (
    !("quoteRequestCount" in value) ||
    value["quoteRequestCount"] === undefined
  )
    return false;
  if (
    !("quoteRequestsWithCarriers" in value) ||
    value["quoteRequestsWithCarriers"] === undefined
  )
    return false;
  if (
    !("totalResponseCount" in value) ||
    value["totalResponseCount"] === undefined
  )
    return false;
  if (
    !("unreadResponseCount" in value) ||
    value["unreadResponseCount"] === undefined
  )
    return false;
  return true;
}

export function ManualQuoteShipmentDetailsFromJSON(
  json: any,
): ManualQuoteShipmentDetails {
  return ManualQuoteShipmentDetailsFromJSONTyped(json, false);
}

export function ManualQuoteShipmentDetailsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ManualQuoteShipmentDetails {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    bolNumber: json["bolNumber"] == null ? undefined : json["bolNumber"],
    pickupLocation: LocationFromJSON(json["pickupLocation"]),
    deliveryLocation: LocationFromJSON(json["deliveryLocation"]),
    isManualQuotingOpen: json["isManualQuotingOpen"],
    companyName: json["companyName"],
    quoteRequestCount: json["quoteRequestCount"],
    quoteRequestsWithCarriers: (
      json["quoteRequestsWithCarriers"] as Array<any>
    ).map(EmailQuoteRequestInfoFromJSON),
    totalResponseCount: json["totalResponseCount"],
    unreadResponseCount: json["unreadResponseCount"],
    operationsAssignedTo:
      json["operationsAssignedTo"] == null
        ? undefined
        : json["operationsAssignedTo"],
    operationsAssignedAt:
      json["operationsAssignedAt"] == null
        ? undefined
        : json["operationsAssignedAt"],
  };
}

export function ManualQuoteShipmentDetailsToJSON(
  json: any,
): ManualQuoteShipmentDetails {
  return ManualQuoteShipmentDetailsToJSONTyped(json, false);
}

export function ManualQuoteShipmentDetailsToJSONTyped(
  value?: ManualQuoteShipmentDetails | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    bolNumber: value["bolNumber"],
    pickupLocation: LocationToJSON(value["pickupLocation"]),
    deliveryLocation: LocationToJSON(value["deliveryLocation"]),
    isManualQuotingOpen: value["isManualQuotingOpen"],
    companyName: value["companyName"],
    quoteRequestCount: value["quoteRequestCount"],
    quoteRequestsWithCarriers: (
      value["quoteRequestsWithCarriers"] as Array<any>
    ).map(EmailQuoteRequestInfoToJSON),
    totalResponseCount: value["totalResponseCount"],
    unreadResponseCount: value["unreadResponseCount"],
    operationsAssignedTo: value["operationsAssignedTo"],
    operationsAssignedAt: value["operationsAssignedAt"],
  };
}
